import Common from '../../Common';
import Account from './queue/Account';

interface Body {
	ast_queue_id: id
}

const Queue = class extends Common {
	account: InstanceType<typeof Account>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.account = new Account(headers);
	}

	async read(profileId: id, queueId: id) {
		return this.get(`/profile/${profileId}/queue/${queueId}`)
	}

	async browse(profileId: id) {
		return this.get(`/profile/${profileId}/queue`)
	}

	async create(profileId: id, body: Body) {
		return this.post(`/profile/${profileId}/queue`, body)
	}

	async update(profileId: id, queueId: id, body: Body) {
		return this.patch(`/profile/${profileId}/queue/${queueId}`, body)
	}

	async delete(profileId: id, queueId: id) {
		return this.doDelete(`/profile/${profileId}/queue/${queueId}`)
	}
}

export default Queue;
